import { ContainedIcon } from '@frontend/icons';

export const ScheduleRescheduled = ({ as = 'span' }: { as?: React.ElementType }) => {
  return (
    <ContainedIcon
      as={as}
      css={{
        padding: 1,
        borderRadius: 'var(--fabric-radius-sm)',
      }}
      iconName='reschedule'
      color={'var(--fabric-color-eggplant-50)'}
    />
  );
};
